import {
  useRadioGroup,
  VStack,
  FormControl,
  FormLabel,
  Input,
  HStack,
  Heading,
  Button,
} from '@chakra-ui/react'
import { useContext, useState } from 'react'
import {
  useContractRead,
  useContractWrite,
  usePrepareContractWrite,
  useWaitForTransaction,
} from 'wagmi'
import RadioCard from '../RadioCard'
import RockPaperScissorsABI from '../../assets/constants/abi/RockPaperScissors.json'
import NetworkMapping from '../../assets/constants/network-mapping.json'
import { RPSContext } from '../../context/RPSContext'

const RevealSecret = () => {
  const [phrase, setPhrase] = useState('')
  const options = ['Rock', 'Paper', 'Scissors']
  const { setGameDetails, gameDetails, nextForm } = useContext(RPSContext)

  const { getRootProps, getRadioProps, value } = useRadioGroup({
    name: 'RockPaperScissors',
    defaultValue: 'Rock',
  })

  const { config } = usePrepareContractWrite({
    address: NetworkMapping['80001']['RockPaperScissors'] as `0x${string}`,
    abi: RockPaperScissorsABI,
    functionName:
      gameDetails.player === gameDetails.initiator ? 'addInitiatorChoice' : 'addResponderChoice',
    args: [
      gameDetails.player === gameDetails.initiator ? gameDetails.responder : gameDetails.initiator,
      options.indexOf(value as string) + 1,
      phrase,
    ],
    enabled: gameDetails.state === 1,
  })

   useContractRead({
    address: NetworkMapping['80001']['RockPaperScissors'] as `0x${string}`,
    abi: RockPaperScissorsABI,
    functionName: 'getGameDetails',
    args: [gameDetails.initiator, gameDetails.responder],
    watch: true,
    enabled: gameDetails.initiator && gameDetails.responder,
    onSuccess(gameState: any) {
      setGameDetails({
        ...gameDetails,
        state: gameState.state,
        initiator_state: gameState.initiator_state,
        responder_state: gameState.responder_state,
      })
    },
  })

  const { data, write } = useContractWrite(config)

   useWaitForTransaction({
    hash: data?.hash,
    onSuccess() {
      nextForm(5)
    },
  })

  function takeAction() {
    write?.()
  }

  const group = getRootProps()
  return (
    <VStack minW={{ base: 'md', md: 'lg', lg: 'lg' }}>
      <Heading>Reveal Secret</Heading>
      <FormControl id="createHash">
        <FormLabel>Selected Option</FormLabel>
        <HStack {...group} mb={'1rem'}>
          {options.map((value) => {
            const radio = getRadioProps({ value })
            return (
              <RadioCard key={value} {...radio}>
                {value}
              </RadioCard>
            )
          })}
        </HStack>
      </FormControl>
      <FormControl id="createHash">
        <FormLabel>
          Secret Word <span style={{ color: 'brown' }}>[Case Sensitive]</span>
        </FormLabel>
        <Input
          placeholder="Secret Word"
          _placeholder={{ color: 'gray.500' }}
          type="text"
          onChange={(e) => setPhrase(e.target.value)}
          value={phrase}
          maxW={'md'}
        />
      </FormControl>
      <Button
        w="7rem"
        colorScheme="teal"
        variant="outline"
        onClick={(e) => {
          e.preventDefault()
          takeAction()
        }}
        isDisabled={false}
      >
        Submit Tx
      </Button>
    </VStack>
  )
}
export default RevealSecret
